/*
 * @Author: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @Date: 2024-06-14 17:00:17
 * @LastEditors: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @LastEditTime: 2024-07-05 15:31:25
 * @FilePath: \xdjs-manage\ruoyi-ui\src\api\distributor\distributor.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import request from '@/utils/request'


// 查询分销商列表
export function listDistributor(query) {
  return request({
    url: '/distributor/distributor/list',
    method: 'get',
    params: query
  })
}

// 查询分销商分页
export function pageDistributor(query) {
  return request({
    url: '/distributor/distributor/page',
    method: 'get',
    params: query
  })
}
export function resetDistributor(query) {
  return request({
    url: '/distributor/distributor/reset',
    method: 'get',
    params: query
  })
}
// 查询分销商详细
export function getDistributor(data) {
  return request({
    url: '/distributor/distributor/detail',
    method: 'get',
    params: data
  })
}

// 新增分销商
export function addDistributor(data) {
  return request({
    url: '/distributor/distributor/add',
    method: 'post',
    data: data
  })
}

// 修改分销商
export function updateDistributor(data) {
  return request({
    url: '/distributor/distributor/edit',
    method: 'post',
    data: data
  })
}

// 删除分销商
export function delDistributor(data) {
  return request({
    url: '/distributor/distributor/delete',
    method: 'post',
    data: data
  })
}
// 导入数据
export function importData(data) {
  return request({
    url: '/distributor/distributor/importData',
    method: 'post',
    data: data
  })
}
